import { Component, OnInit, Input, OnChanges, ChangeDetectionStrategy, ChangeDetectorRef, ElementRef, AfterViewInit , Inject, PLATFORM_ID} from '@angular/core';
import { MediaCellConfig } from 'angular-engine/modules/ng-express-engine/tokens';
import { EventInteraction } from 'angular-engine/engine/service/dynamic/event.interaction.service';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
@Component({
    selector: 'video-detail',
    templateUrl: './video-detail.template.html',
    styleUrls: ['./video-detail.style.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class VideoDetail {
    @Input() item: any;
    @Input() config: MediaCellConfig;
    @Input() snipe;
    @Input() unfold: boolean;
    @Input() numberOfLines: number;
    @Input() tall : boolean = false;
    @Input() lineheight : number = 0;
    private el : ElementRef;
    private isServer = false;
    private descriptionHeight : number = 0; 
    private changes: boolean = false;
    
    constructor(private cd: ChangeDetectorRef,private interactions : EventInteraction, el : ElementRef, @Inject(PLATFORM_ID) platformId: string ){ 
        this.el = el.nativeElement;
        this.isServer = isPlatformServer(platformId)
    }

    public settings : any = {
        showCopy: true,
        showTags: true,
        showTitle: true,
        showSub: true
    }

    ngOnChanges(changes) {
        this.changes = true;
    }

    ngAfterViewChecked() {
        if(this.changes)
        {
            this.calculateContentHeight();
            this.changes = false;
        }
    }

    calculateContentHeight() {
        if( !this.numberOfLines  || this.isServer)
        return ;

        let container = this.el['getElementsByClassName']('expandable-container');
        let paragraphs;
        let txt;
        let height = 0;
        
        let margin; 
        let paddingTop;
        let paddingBottom;
        let marginTop;
        let marginBottom;

        if( container[0]){
            container = container[0];
            paragraphs = container.getElementsByTagName('p');
            txt = paragraphs;
        }

        if ( txt.length ){
            this.lineheight = Number(window.getComputedStyle( txt[0] ).lineHeight.match(/[0-9]*/)[0]);
            
            for(var i=0; i < txt.length; i++)
            {
                
                this.descriptionHeight += Number(window.getComputedStyle( txt[i] ).height.match(/[0-9]*/)[0]);
                height += txt[i].getClientRects()[0].height;
            }
            
            

            if ((height > (this.lineheight * this.numberOfLines )) || (container.childElementCount > 1)){
                this.tall = true;
                this.cd.detectChanges();
            }
            else
            {
                this.tall = false;
                this.cd.detectChanges();
            }
        }
    }
    
    ngAfterViewInit(){
        this.calculateContentHeight();
    }

    ngOnInit() {
        //apply default config
        Object.assign(this.settings, this.config);
    }

    toggleFold(  ){
        if ( !this.unfold ){
            this.unfold = true
        }else{
            this.unfold = false;
        }
        this.interactions.next({key: 'toggle-video-content', message: this.unfold});
        this.cd.detectChanges();
    }

    public maxHeight(){
         let height= !this.unfold ? (this.lineheight * this.numberOfLines).toString() + "px" : "initial";
         return height;
    }

    
}


// WEBPACK FOOTER //
// ./src/angular-framework-client-components/components/video-detail/video-detail.component.ts